import styled from 'styled-components';

import ReportCheckBox from '@/components/atom/icon/checkBox/ReportCheckBox';

export interface QnaWriteAdditionalInfoProps {
  onClickCheckPregnant: () => void;
  pregnant: boolean;
}

const QnaWriteAdditionalInfo = ({
  onClickCheckPregnant,
  pregnant,
}: QnaWriteAdditionalInfoProps) => {
  return (
    <Wrapper>
      <button type="button" onClick={onClickCheckPregnant}>
        <ReportCheckBox isChecked={pregnant} marginRight={8} />
        <p>현재 임신 중입니다.</p>
      </button>
    </Wrapper>
  );
};

export default QnaWriteAdditionalInfo;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > button {
    border: none;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0;

    & > p {
      ${({ theme }) => theme.typography.UI16M};
      color: ${({ theme }) => theme.color.gray400};
    }
  }

  div:last-of-type {
    ${({ theme }) => theme.typography.UI14M};
    color: ${({ theme }) => theme.color.blue500};
  }
`;
